import { render, staticRenderFns } from "./AppleStoreBadge.vue?vue&type=template&id=4e27190e&"
import script from "./AppleStoreBadge.vue?vue&type=script&lang=js&"
export * from "./AppleStoreBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports